var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pill",class:{ "pill--active": _vm.active, "pill--danger": _vm.danger }},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon}}):_vm._e(),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }